<template>
  <div>
    <b-table
    :data="chaptersFiltered"
    :loading="isLoading"
    hoverable
    per-page="25"
    >
      <template slot-scope="props">
        <b-table-column field="chapter" label="ตอนที่" centered numeric>
          <div class="buttons is-centered">
            <button class="button is-primary" @click="goToChapter(props.row)">
              <b-icon pack="fas" icon="fire" size="is-small"></b-icon>
              <span>อ่านตอน {{ props.row.chapter }}</span>
            </button>
          </div>
        </b-table-column>

        <b-table-column field="novel" label="เรื่อง" centered>
          <router-link class="tag" :to="`/novel/${props.row['novel_id']}`">{{ novelName(props.row) }}</router-link>
        </b-table-column>
        <b-table-column field="author" label="ผู้แปล" centered>
          <span class="tag">{{ props.row.author }}</span>
        </b-table-column>

        <b-table-column field="date" label="ลงวันที่">
          <span class="tag is-success">
              {{ dateFormatted(props.row['post_date']) }}
          </span>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
            <div class="content has-text-grey has-text-centered">
                <p><i class="far fa-sad-tear"></i></p>
                <span v-if="isLoading"><p>Loading...</p></span>
                <span v-else><p>Nothing here.</p></span>
            </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import { db } from '@/firebase.config'

export default {
  name: 'latest',
  data () {
    return {
      chapters: [],
      novels: this.$root.novels,
      isLoading: false
    }
  },
  computed: {
    chaptersFiltered () {
      return this.chapters.filter(chapter => {
        var novel = this.novels.find(novel => novel.id === chapter['novel_id'])
        return (novel.isHidden === true && this.donateTotal(novel.id) > 0) || this.$root.isImmortal || !novel.isHidden
      })
    }
  },
  methods: {
    goToChapter (row) {
      this.$router.push({
        name: 'chapter',
        params: {
          novelId: row['novel_id'],
          chapterId: row.chapter.toString()
        }
      })
    },
    dateFormatted (date) {
      var options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
      return date.toDate().toLocaleDateString('en-GB', options)
    },
    novelName (row) {
      if (this.novels.length > 0) {
        return this.novels.find(novel => novel.id === row['novel_id']).name
      }
    },
    loadAsyncData () {
      this.isLoading = true
      db.collection('chapters')
        .where('status', '==', 'public')
        .orderBy('post_date', 'desc')
        .limit(25)
        .get()
        .then(snapshot => {
          if (!snapshot.empty) {
            this.chapters = snapshot.docs.map(doc => doc.data())
          }
          this.isLoading = false
        })
        .catch(error => {
          this.$dialog.alert({ title: 'เกิดข้อผิดพลาด!', message: error.toString(), type: 'is-danger' })
          this.isLoading = false
        })
    },
    donateTotal (novelId) {
      var completedPayments = this.$root.payments.filter(payment => payment.status === 'completed' && payment.novel_id === novelId)
      if (completedPayments.length > 0) {
        return completedPayments.map(payment => parseInt(payment.amount)).reduce((prev, next) => prev + next)
      }
      return 0
    }
  },
  mounted () {
    this.loadAsyncData()
  }
}
</script>

<style lang="scss">

</style>
